import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Connect } from './SearchResultLawfirmContainer';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from '../../../../../components/modal/components/modal-restricted/withRestrictedModal';
import { Hyperlink } from '../../../../../components/Hyperlink';
import { AddEntityWatcherButton } from '../../../../../watchers/components/add-entity-watcher/AddEntityWatcherButton';
import { buildUrlWithParameters } from '../../../../../utils/url-utils/urlUtils';
import { doctrineAnalytics } from '../../../../../utils/analyticsUtils';
import {
  SearchCard,
  FollowContainer,
  SearchCardTitle,
  SearchCardFooter,
} from '../../results-card';
import { LawFirmCardTitle } from '../../../../../law-firm/card/LawFirmCardTitle';
import { QueryParamsType } from '../../../../state/reducers/queryParams.types';
import {
  EntitiesList,
  EntitiesListItem,
} from '../../../../../components/entities-card/EntitiesList';
import { AnimatedLink } from '../../../../../components/animated-link/AnimatedLink';
import { UserContextType } from '../../../../../user/user.types';
import { withUser } from '../../../../../user/UserContext';
import { LawfirmHit } from '../../../../search.types';

type Props = {
  lawfirm: LawfirmHit;
  originalQueryKey: QueryParamsType['originalQueryKey'];
} & UserContextType &
  WithRestrictedModalProps;

class RawSearchResultLawfirm extends React.Component<Props> {
  protectFeature = (source: string) => (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  ) => {
    const { accessPremium, openRestrictedModal } = this.props;
    if (!accessPremium) {
      event.preventDefault();
      openRestrictedModal(source);
    }
  };

  onButtonClick = (isAdded: boolean) => {
    const { lawfirm } = this.props;
    if (isAdded) {
      doctrineAnalytics('Search LawyFirmWatchClicked', {
        law_office_id_group: lawfirm.lawOfficeIdGroup,
      });
    }
  };

  render() {
    const {
      accessPremium,
      lawfirm,
      openRestrictedModal,
      originalQueryKey,
    } = this.props;
    const lawfirmUrl = accessPremium
      ? buildUrlWithParameters(lawfirm.url, {
          source: 'search_results_law_firm',
          original_query_key: originalQueryKey,
        })
      : '';
    const hasOffices = lawfirm.offices.length > 0;
    const parsedLawFirmsLawyerCount = parseInt(lawfirm.nbLawyers, 10);

    return (
      <SearchCard>
        <SearchCardTitle>
          <LawFirmCardTitle
            onClick={this.protectFeature('search_results_law_firm_header')}
            href={lawfirmUrl}
          >
            {lawfirm.name}
          </LawFirmCardTitle>
        </SearchCardTitle>

        {hasOffices && (
          <div>
            <span className="search_card__lawyer__right__infos__text">
              {lawfirm.nbOffices}{' '}
              <FormattedMessage id="search/components/search-results/lawyer-lawfirm/lawfirm/SearchResultLawfirm.tsx/1" />
              {lawfirm.nbOffices > 1 ? 'x' : ''}
            </span>
            {lawfirm.offices.slice(0, 5).map(office => (
              <div key={office.url}>
                <FormattedMessage id="search/components/search-results/lawyer-lawfirm/lawfirm/SearchResultLawfirm.tsx/2" />
                <Hyperlink
                  onClick={this.protectFeature('search_results_law_office')}
                  href={
                    accessPremium ? `${office.url}?source=search_result` : ''
                  }
                  className="search_card__firm__office"
                >
                  {office.postalCity}
                </Hyperlink>
                {office.nbLawyers > 0 && (
                  <span>
                    <FormattedMessage
                      id="search/components/search-results/lawyer-lawfirm/lawfirm/SearchResultLawfirm.tsx/3"
                      values={{ lawyerCount: office.nbLawyers }}
                    />
                  </span>
                )}
              </div>
            ))}
          </div>
        )}
        {lawfirm.offices.length === 0 && (
          <EntitiesList>
            {lawfirm.postalCity && (
              <EntitiesListItem left="Ville" right={lawfirm.postalCity} />
            )}
            {parsedLawFirmsLawyerCount > 0 && (
              <EntitiesListItem
                left="Nombre d’avocats référencés"
                right={`${parsedLawFirmsLawyerCount} avocat${
                  parsedLawFirmsLawyerCount > 1 ? 's' : ''
                }`}
              />
            )}
          </EntitiesList>
        )}
        <FollowContainer>
          <AddEntityWatcherButton
            queryParams={{ oid: lawfirm.lawOfficeIdGroup, q: lawfirm.name }}
            uniqueId={lawfirm.lawOfficeIdGroup}
            onButtonClick={this.onButtonClick}
            restrict={() => openRestrictedModal('law_firm_snippet')}
            source="law_firm_snippet"
            secondary
          />
        </FollowContainer>
        {lawfirm.url && (
          <SearchCardFooter>
            <AnimatedLink
              onClick={this.protectFeature('search_results_law_firm_bottom')}
              href={lawfirmUrl}
            >
              <FormattedMessage id="search/components/search-results/lawyer-lawfirm/lawfirm/SearchResultLawfirm.tsx/6" />
            </AnimatedLink>
          </SearchCardFooter>
        )}
      </SearchCard>
    );
  }
}

export const SearchResultLawfirm = withUser(
  withRestrictedModal(Connect(RawSearchResultLawfirm)),
);
